import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import HotelSearchBroadSearchLocation from 'components/Pages/HotelSearchPage/HotelSearchBroadSearchLocation'
import React from 'react'
import { connect } from 'react-redux'
import { getUrlOfferListFilters } from 'selectors/routerSelectors'

interface Props {
  filters: App.OfferListFilters
  specificPlaces: Array<App.SpecificPlace>
  isWithPromo: boolean
}

function SecondChanceModalSearchCarousel({ specificPlaces, isWithPromo }:Props) {
  return (
    <>
      {isWithPromo &&
        <HeadingTextBlock variant="heading6">
          Find your perfect escape from the top destinations!
        </HeadingTextBlock>}
      <HotelSearchBroadSearchLocation
        specificPlaces={specificPlaces}
        showTitle={false}
        arrowsOnlyOnHover
      />
    </>
  )
}
function mapState(state: App.State) {
  const filters = getUrlOfferListFilters(state)
  return {
    filters,
    specificPlaces: state.destination.specificPlaces[filters.destinationId ?? ''],
  }
}

export default connect(mapState)(SecondChanceModalSearchCarousel)
